<template>
  <div class="input-item">
    <input ref="input" v-bind="$props" @blur="handleBlur" @focus="handleFocus" @input="handleInput">
    <span v-if="isShowClear" @click="clear">
      <i class="icon clear"></i>
    </span>
  </div>
</template>

<script>
import { removeSpaceChar } from 'utils/string';

export default {
  props: ['type', 'value', 'placeholder'],
  data() {
    return {
      currentVal: this.value,
      isFoucus: false,
    };
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
  },
  computed: {
    isShowClear() {
      return this.isFoucus && this.value;
    },
  },
  methods: {
    removeSpaceChar,
    handleBlur(event) {
      const {
        value,
      } = event.target;
      event.target.scrollIntoView(false);
      this.$emit('input', this.removeSpaceChar(value));
      this.isFoucus = false;
    },
    handleFocus(e) {
      setTimeout(() => {
        e.target.scrollIntoView(true);
      }, 100);
      this.isFoucus = true;
    },
    handleInput(event) {
      const {
        value,
      } = event.target;
      this.setCurrentValue(value);
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = this.removeSpaceChar(value);
      this.$emit('input', value);
    },
    clear() {
      this.$emit('input', '');
      this.focus();
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style lang="scss">
.input-item {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  input {
    flex: 1;
    font-size: 26px;
    height: 100%;
  }

  span {
    display: inline-block;
    width: 40px !important;
  }
}
</style>
